import { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { OverlayPlacement } from '@heroui/aria-utils';
import { Tooltip } from '@heroui/react';

type TruncatedProps = {
  value: string;
  tooltipOptions?: {
    placement: OverlayPlacement;
    showArrow: boolean;
    className?: string;
  };
  valueClassName?: string;
};

const TruncatedWithTooltip = ({
  value,
  tooltipOptions = { placement: 'top', showArrow: true },
  valueClassName,
}: TruncatedProps) => {
  const valueRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = valueRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [value]);

  if (isTruncated) {
    return (
      <Tooltip content={value} {...tooltipOptions}>
        <span className={classnames('truncate', valueClassName)}>{value}</span>
      </Tooltip>
    );
  }

  return (
    <span className={classnames('truncate', valueClassName)} ref={valueRef}>
      {value}
    </span>
  );
};

export default TruncatedWithTooltip;
